import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Form as FinalForm } from 'react-final-form';
import { Form } from "antd";
import classNames from 'classnames';

import Button from 'components/Shared/Common/Button';
import Drawer from 'components/Shared/Drawers';
import FeedInput from 'components/Shared/Forms/FeedInput';
import { ButtonActions } from 'components/Shared/styles';
import CategoryTitle from 'components/Shared/Layout/CategoryTitle';
import Icon from 'components/Shared/Common/Icon';

const DrawerEditGroup = memo(({
    onClose,
    intl,
    initialValues: { feed },
    validators,
    onRemoveFeed,
    onSubmit,
}) => {
    const initialValues = useMemo(() => ({ feed }), [feed.id]);
    const translations = useMemo(() => ({
        title: intl.formatMessage({ id: 'drawer.editGroup.title' }),
        deleteFeed: intl.formatMessage({ id: 'feed.header.dropdown.deleteFeed' }),
    }), [intl]);

    return (
        <Drawer
            isOpen
            onClose={onClose}
            placement="left"
            title={(
                <CategoryTitle
                    label={translations.title}
                    icon={<Icon size="xl" iconName="MessageCircle" />}
                />
            )}
        >
            <FinalForm onSubmit={onSubmit} initialValues={initialValues}>
                {({ handleSubmit, pristine, submitting, form }) => (
                    <Form onSubmit={handleSubmit} layout="vertical">
                        <FeedInput name="feed" validators={validators} canInvit />
                        <ButtonActions
                            className={classNames({ 'spaced': feed?.id })}>
                            {feed?.id && (
                                <Button
                                    iconName="Trash2"
                                    onClick={() => onRemoveFeed(feed.id, feed.name)}
                                    color="danger"
                                    size="md"
                                >
                                    {translations.deleteFeed}
                                </Button>
                            )}
                            <Button
                                iconName="Check"
                                onClick={form.submit}
                                color="primary"
                                isDisabled={pristine || submitting}
                                size="lg"
                            />
                        </ButtonActions>
                    </Form>
                )}
            </FinalForm>
        </Drawer>
    );
});

DrawerEditGroup.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    intl: PropTypes.any.isRequired,
    validators: PropTypes.shape({
        required: PropTypes.func.isRequired
    }).isRequired,
};

export default injectIntl(DrawerEditGroup);
